module.exports = __webpack_public_path__ + "img/sand-dune-decal-14.f82e3397.png";